module.exports = __webpack_public_path__ + "static/media/arena-web.133454ce.png";